// HM-323 cluster 15.5: store zustand mono-selezione del filtro stato
// camere nella pagina /camere. Default 'all'. Click pill diversa
// resetta la precedente. NON multi-selezione (cluster 15.3 invece e'
// multi nel Dashboard - rimosso in 15.4).

import { create } from 'zustand';
import type { RoomDb } from '../api/rooms.js';

export type RoomFilterValue = 'all' | RoomDb['status'];

type State = {
  selectedFilter: RoomFilterValue;
  setSelectedFilter: (v: RoomFilterValue) => void;
};

export const useRoomFilterStore = create<State>((set) => ({
  selectedFilter: 'all',
  setSelectedFilter: (v) => set({ selectedFilter: v }),
}));
